import { List, Map } from "react-feather";
import styles from "./toolbar.module.css";

// List / Map toggle for the work lists; labels hide on phones, icons stay
const ViewSwitch = ({ value, onChange, order = ["list", "map"] }) => {
  const options = { list: { label: "List", icon: <List size={16} /> }, map: { label: "Map", icon: <Map size={16} /> } };
  return (<div className={styles.Switch} role="group" aria-label="Choose view">
    {order.map((key) => (<button
      type="button"
      key={key}
      aria-pressed={value === key}
      aria-label={`${options[key].label} view`}
      className={`${styles.SwitchBtn} ${value === key ? styles.SwitchActive : ""}`}
      onClick={() => onChange(key)}
    >
      {options[key].icon}<span>{options[key].label}</span>
    </button>))}
  </div>);
};

export default ViewSwitch;
